import { UserFormState } from "@/types/users.types";
import { LoginMethodEnum } from "../types/authentication.types";

import { tr } from '@/i18n';
export const LOGIN_METHODS = [
  { value: "all", label: tr("ui.all_methods_f9082d", "All Methods") },
  { value: LoginMethodEnum.Manual, label: tr("ui.manual", "Manual") },
  { value: LoginMethodEnum.Saml, label: tr("ui.saml", "SAML") },
  { value: LoginMethodEnum.Oauth, label: tr("ui.oauth", "OAuth") },
];

export const INITIAL_USER_FORM_STATE: UserFormState = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: null,
  loginmethod: '',
  deleted: false,
  suspended: false,
  locked: false,
  mobile: null,
  summary: null,
  lang: 'en',
  // The user sync may update them (an admin can turn it off per person).
  sync: true,
  force_password_change: false,
  role_ids: [],
  firstaccess: undefined,
  lastaccess: undefined,
};